<template>
  <v-layout>
    <v-flex>
      <v-layout wrap align-center>
        <h1 class="headline">Payment Types</h1>
        <v-spacer></v-spacer>
        <v-flex xs12 sm4 class="pb-2">
          <v-text-field
            append-icon="mdi-magnify"
            label="Quick Filter..."
            single-line
            hide-details
            v-model="search"
            class="ma-0"
            :outlined="outlinedInputs"
          ></v-text-field>
        </v-flex>
        <v-tooltip bottom>
          <template v-slot:activator="{on}">
            <v-btn v-on="on" fab dark color="primary" @click="createItem" class="ma-2">
              <v-icon dark>mdi-plus</v-icon>
            </v-btn>
          </template>
          <span>Create New Payment Type</span>
        </v-tooltip>
      </v-layout>
      <v-card>
        <v-data-table
          :headers="headers"
          :items="paymentTypes.edges"
          :loading="$apollo.loading"
          v-bind="pagingOptions"
          :search="search"
          item-key="node.id"
        >
          <template v-slot:item.actions="{item}">
            <default-list-actions
              :item="item"
              :hide-view="true"
              @deleteItem="deleteItem($event)"
              @editItem="editItem($event)"
            ></default-list-actions>
          </template>
        </v-data-table>
      </v-card>
      <v-card>
        <v-dialog v-model="paymentTypeEditorDialog" persistent width="500">
          <v-card>
            <payment-type-editor
              :paymentType="selectedPaymentType"
              :doSavePaymentType="doSavePaymentType"
              :paymentTypeEditorDialog="paymentTypeEditorDialog"
              @saved="onSaved($event)"
              @onResetSave="onResetSave"
            ></payment-type-editor>
            <v-card-actions class="grey lighten-4">
              <v-spacer></v-spacer>
              <v-btn color="warning" text @click="closeDialog">Cancel</v-btn>
              <v-btn color="primary" @click="onSavePaymentType">Save</v-btn>
            </v-card-actions>
          </v-card>
        </v-dialog>
      </v-card>
    </v-flex>
  </v-layout>
</template>

<script>
import {
  ALL_PAYMENTS_TYPES_SEARCH_QUERY,
  PAYMENT_TYPE_DELETE_MUTATION
} from "../../../../constants/graphql";
import DefaultListActions from "../../shared/DefaultListActions";
import PaymentTypeEditor from "./PaymentTypeEditor";
import { pagingOptions } from "../../../../helpers/index";

export default {
  name: "PaymentTypesList",

  components: {
    DefaultListActions,
    PaymentTypeEditor
  },

  data() {
    return {
      pagingOptions,
      search: "",
      paymentTypes: {},
      selectedPaymentType: {},
      doSavePaymentType: false,
      paymentTypeEditorDialog: false,
      headers: [
        {
          text: "Name",
          align: "left",
          value: "node.name",
          name: "name"
        },
        {
          text: "Actions",
          value: "actions",
          sortable: false,
          name: "actions",
          align: "center"
        }
      ]
    };
  },

  computed: {
    outlinedInputs() {
      return this.$store.getters.localSettings("outlinedInputs");
    }
  },

  methods: {
    createItem() {
      this.selectedPaymentType = {};
      this.paymentTypeEditorDialog = true;
    },
    editItem(item) {
      this.selectedPaymentType = item.node;
      this.paymentTypeEditorDialog = true;
    },
    deleteItem(item) {
      this.$apollo
        .mutate({
          mutation: PAYMENT_TYPE_DELETE_MUTATION,
          variables: {
            paymentTypeId: item.node.id
          }
        })
        .then(this.removeGqlObjectHandler, this.removeGqlObjectErrorHandler);
    },
    removeGqlObjectHandler(result) {
      this.$store.dispatch("showAppSnackbar", { msg: "Payment type removed." });
      if (this.$apollo.queries.paymentTypes != null) {
        this.$apollo.queries.paymentTypes.refetch();
      }
    },
    removeGqlObjectErrorHandler(err) {
      this.$store.dispatch("showAppSnackbar", {
        msg: err.graphQLErrors[0].message,
        color: "error"
      });
    },
    onSaved(context) {
      if (this.$apollo.queries.paymentTypes != null) {
        this.$apollo.queries.paymentTypes.refetch();
      }
      this.onResetSave();
      this.paymentTypeEditorDialog = false;
      this.selectedPaymentType = {};
      let msg =
        context == "edit" ? "Payment type updated." : "Payment type created.";
      this.$store.dispatch("showAppSnackbar", { msg });
    },
    onResetSave() {
      this.doSavePaymentType = false;
    },
    closeDialog() {
      this.paymentTypeEditorDialog = false;
      this.selectedPaymentType = {};
    },
    onSavePaymentType() {
      this.doSavePaymentType = true;
    }
  },

  apollo: {
    paymentTypes: {
      query: ALL_PAYMENTS_TYPES_SEARCH_QUERY,
      fetchPolicy: "network-only",
      result({ data, loader, networkStatus }) {}
    }
  }
};
</script>

<style scoped>
</style>



// WEBPACK FOOTER //
// src/components/gt/admin/currencies/PaymentTypesList.vue